import axios from "axios";

export function getAllActive() {
    return axios.get("/api/services/app/Institution/GetAllActive");
}
